/** Kinds of widget a workspace tab can add. */
export type WidgetKind =
  | "chart"
  | "portfolioHistory"
  | "balances"
  | "watchlist"
  | "optionsChain"
  | "positions"
  | "orders"
  | "activities"
  | "orderTicket";

export type WidgetKindMeta = {
  /** Title Case / product spelling for chrome titles and the Add-widget menu. */
  label: string;
  /**
   * Shows the lettered group selector. Watchlist and Order Ticket publish;
   * Chart, Options, Positions, Orders, and Activities consume. Portfolio
   * History and Balances remain account-wide and do not participate in symbol
   * groups.
   */
  isSingleSymbol: boolean;
};

/**
 * Per-kind capabilities and display metadata — single source of truth for
 * widget chrome titles, the Add-widget menu, and group-selector gating.
 */
export const WIDGET_KIND_META: Record<WidgetKind, WidgetKindMeta> = {
  chart: { label: "Chart", isSingleSymbol: true },
  portfolioHistory: { label: "Portfolio History", isSingleSymbol: false },
  balances: { label: "Balances", isSingleSymbol: false },
  watchlist: { label: "Watchlist", isSingleSymbol: true },
  optionsChain: { label: "Options Chain", isSingleSymbol: true },
  orderTicket: { label: "Order Ticket", isSingleSymbol: true },
  positions: { label: "Positions", isSingleSymbol: true },
  orders: { label: "Order Blotter", isSingleSymbol: true },
  activities: { label: "Activities", isSingleSymbol: true },
};

export const WIDGET_KIND_OPTIONS: ReadonlyArray<{
  kind: WidgetKind;
  label: string;
}> = (
  Object.entries(WIDGET_KIND_META) as Array<[WidgetKind, WidgetKindMeta]>
).map(([kind, { label }]) => ({ kind, label }));
